import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import {
  Typography,
  IconButton,
  List,
  Box,
  ListItem,
  AppBar,
  Toolbar,
  ListItemText
} from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'

import CustomDrawer from '~/components/Drawer'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    gap: 16,
    display: 'flex',
    alignItems: 'center',
    '& .MuiButtonBase-root': {
      padding: 8
    }
  },
  paper: {
    width: theme.gofind.asideWidth,
    position: 'absolute',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    ...theme.gofind.scrollBar,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export function StorePeriod({ isOpen, setIsOpen, store, weekdaysPeriod }) {
  const classes = useStyles()
  const mappedWeekdays = weekdaysPeriod.map((weekday) => weekday.split(',').map((i) => i.trim()))

  const handleClose = () => setIsOpen(false)

  return (
    <CustomDrawer open={isOpen}>
      <AppBar position="static">
        <Toolbar classes={{ root: classes.toolbar }}>
          <IconButton edge="start" color="inherit" onClick={handleClose}>
            <ArrowBack />
          </IconButton>
          <Typography>{store?.name}</Typography>
        </Toolbar>
      </AppBar>
      <List>
        {mappedWeekdays.map(([day, time]) => (
          <ListItem key={day} style={{ padding: 16 }}>
            <ListItemText
              primary={
                <Box display="flex" justifyContent="space-between">
                  <Typography>{day}</Typography>
                  <Typography>{time}</Typography>
                </Box>
              }
            ></ListItemText>
          </ListItem>
        ))}
      </List>
    </CustomDrawer>
  )
}
